export default __webpack_public_path__ + "static/media/workout.cd63edf1.jpeg";